[
  {
    "key": "cultureLaunchCta",
    "text": "Explore Zenithr Culture Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استكشف استبيان زينيثر للثقافة المؤسسية"
      },
      {
        "language": "EN",
        "text": "Explore Zenithr Culture Survey"
      }
    ]
  },
  {
    "key": "cultureLaunchPoint3",
    "text": "Turn culture insights into practical action.",
    "translations": [
      {
        "language": "AR",
        "text": "حوّل رؤى الثقافة إلى إجراءات عملية."
      },
      {
        "language": "EN",
        "text": "Turn culture insights into practical action."
      }
    ]
  },
  {
    "key": "cultureLaunchPoint2",
    "text": "Spot gaps across Clan, Adhocracy, Market and Heirarchy.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرّف على الفجوات في أنماط ثقافة الجماعة والإبداع والسوق والهرمية."
      },
      {
        "language": "EN",
        "text": "Spot gaps across Clan, Adhocracy, Market and Heirarchy."
      }
    ]
  },
  {
    "key": "cultureLaunchPoint1",
    "text": "Measure current and preferred culture.",
    "translations": [
      {
        "language": "AR",
        "text": "قِس ثقافة مؤسستك الحالية والثقافة المنشودة."
      },
      {
        "language": "EN",
        "text": "Measure current and preferred culture."
      }
    ]
  },
  {
    "key": "cultureLaunchDesc",
    "text": "Understand your organization's current and preferred culture using OCAI framework.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرّف على ثقافة مؤسستك الحالية والمنشودة باستخدام أداة تقييم الثقافة التنظيمية (OCAI)"
      },
      {
        "language": "EN",
        "text": "Understand your organization's current and preferred culture using OCAI framework."
      }
    ]
  },
  {
    "key": "cultureLaunchTitle",
    "text": "Introducing Zenithr Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "استكشف تقييم زينيثر للثقافة المؤسسية"
      },
      {
        "language": "EN",
        "text": "Introducing Zenithr Culture Assessment"
      }
    ]
  },
  {
    "key": "airLaunchBadge",
    "text": "NEW IN ZENITHR",
    "translations": [
      {
        "language": "AR",
        "text": "جديد في زينيثر"
      }
    ]
  },
  {
    "key": "airLaunchTitle",
    "text": "Introducing Zenithr AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "نقدّم لكم زينيثر لجاهزية الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "airLaunchDesc",
    "text": "Discover how ready your organization is to adopt AI.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف مدى جاهزية مؤسستك لتبنّي الذكاء الاصطناعي."
      }
    ]
  },
  {
    "key": "airLaunchPoint1",
    "text": "Assess AI confidence and capability",
    "translations": [
      {
        "language": "AR",
        "text": "قياس الثقة والقدرة في مجال الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "airLaunchPoint2",
    "text": "Spot strengths and readiness gaps",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد نقاط القوة وفجوات الجاهزية"
      }
    ]
  },
  {
    "key": "airLaunchPoint3",
    "text": "Get a practical starting point for action",
    "translations": [
      {
        "language": "AR",
        "text": "الحصول على نقطة انطلاق عملية للتنفيذ"
      }
    ]
  },
  {
    "key": "airLaunchExplain",
    "text": "Explain how it works",
    "translations": [
      {
        "language": "AR",
        "text": "شرح آلية العمل"
      }
    ]
  },
  {
    "key": "airLaunchMaybeLater",
    "text": "Maybe later",
    "translations": [
      {
        "language": "AR",
        "text": "ربما لاحقًا"
      }
    ]
  },
  {
    "key": "airLaunchCta",
    "text": "Explore Zenithr AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "استكشف زينيثر لجاهزية الذكاء الاصطناعي"
      }
    ]
  }
]